<template>
<div class="chapter">
<div class="inner_page">
<div id="IS-EB-5P-4.html" xml:lang="en-US">
<div class="story">
<h1 id="toc_marker-4"><a id="Anchor-284">Dedication</a></h1><a id="Anchor-284">
<p>This one is for Britton Edwards.</p>
<p class="Basic-Paragraph">
</p><p><em class="italic">Apple has a core set of talents, and those talents are: We do, I think, very good hardware design; we do very good industrial design; and we write very good system and application software. And we’re really good at packaging that all together into a product. We’re the only people left in the computer industry that do that.</em></p>
<p>—Steve Jobs, <em class="italic">Rolling Stone</em>, December 25, 2003</p>
<p class="Basic-Paragraph">
</p></a></div><a id="Anchor-284">
</a></div><a id="Anchor-284">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IS-EB5P-4.vue?da80a42e